// @flow strict

//$FlowFixMe[nonstrict-import]
import type {State} from 'src/reducers';

import type {Filters, ScheduledEvents} from 'src/types/scheduler/events.js';


export const selectPastEventsAPIParams = (state: State): Filters => {
  return state.scheduler.events.past.filters;
};

export const selectPastEvents = (state: State): ScheduledEvents => {
  return state.scheduler.events.past;
};

export const selectUpcomingEventsAPIParams = (state: State): Filters => {
  return state.scheduler.events.upcoming.filters;
};

export const selectUpcomingEvents = (state: State): ScheduledEvents => {
  return state.scheduler.events.upcoming;
};
